module.exports = __webpack_public_path__ + "img/yingyong.09476603.png";